import React from 'react';
import { Label, LabelsContainer, FilterThumbnailsWrapper, ThumbnailLabel } from './styled';
import { config as filterConfig } from '../config';
import { filtersThumbnailsConfig } from './config';
import { getInitialState, isFilterActiveByType } from '../utils';
import { IFiltersState } from '../types';
import { marketplaceSelector } from 'store/state/selectors/router';
import { useSelector } from 'react-redux';


interface FilterThumbnailsProps {
  filters: Partial<IFiltersState>;
  showDealType?: boolean;
}

const FilterThumbnails: React.FC<FilterThumbnailsProps> = ({ filters, showDealType }) => {
  const marketplace = useSelector(marketplaceSelector);

  const filterNames = Object.keys(filters);
  const { dealType } = filters;
  const activeFilters = filterNames
    .filter(item => isFilterActiveByType[item](filters[item], getInitialState(dealType, marketplace)[item], marketplace));

  if (showDealType && filters.dealType) {
    activeFilters.unshift('dealType');
  }

  const renderFilters = () => (
    <LabelsContainer>
      {activeFilters
        .map(filterName => {
          const Component = filtersThumbnailsConfig[filterName];
          return (
            <Label key={filterName}>
              {filterConfig[marketplace].filtersIcons[filterName]}{' '}
              <ThumbnailLabel>
                <Component value={filters[filterName]} initialValue={getInitialState(dealType, marketplace)[filterName]} />
              </ThumbnailLabel>
            </Label>
          );
        })
      }
    </LabelsContainer>
  );

  return (
    <FilterThumbnailsWrapper>
      {renderFilters()}
    </FilterThumbnailsWrapper>
  );
};

export default React.memo(FilterThumbnails);
